// @flow
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import RefreshIcon from '@mui/icons-material/Refresh';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import InfoIcon from '@mui/icons-material/Info';
import CssBaseline from '@mui/material/CssBaseline';
import Avatar from '@mui/material/Avatar';
import SendToMobileIcon from '@mui/icons-material/SendToMobile';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Alert from '@mui/material/Alert';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from './ConfirmDialog';
import PrintIndexDialog from './PrintIndexDialog';
import FolderInfoDialog from './FolderInfoDialog';
import UploadSingleFileDialog from './UploadSingleFileDialog';
import UploadDialog from './UploadDialog';
import RagMessagingDialog from './RagMessagingDialog';
// import SearchDialog from './SearchDialog';
import DocCheckHistTab from './DocCheckHistTab';
import SearchDialogContent from './SearchDialogContent';
import GridSettingDialog from './GridSettingDialog';

import useFileDialog from "use-file-dialog";

import Backdrop from '@mui/material/Backdrop';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import SearchIcon from '@mui/icons-material/Search';
import PageviewSharpIcon from '@mui/icons-material/PageviewSharp';
import PageviewOutlinedIcon from '@mui/icons-material/PageviewOutlined';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import ChatIcon from '@mui/icons-material/Chat';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import Button from '@mui/material/Button';
import { styled, useTheme } from '@mui/material/styles';
import { AgGridReact } from 'ag-grid-react';

import dayjs from "dayjs";

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';


import * as DmsService from '../supports/dms-service'
import { GlobalEvent, GlobalState } from './GlobalContext';
import DocInfoTab from './DocInfoTab';
import * as DmsCommon from '../supports/dms-common';


let DOC_UNKNOWN_IMG = "images/file.png";
let DOC_WORD_IMG = "images/doc.png";
let DOC_DWG_IMG = "images/dwg.png";
let DOC_MSG_IMG = "images/msg.png";
let DOC_HTML_IMG = "images/htm.png";
let DOC_JPG_IMG = "images/jpg.png";
let DOC_MP4_IMG = "images/mp4.png";
let DOC_MOV_IMG = "images/mov.png";
let DOC_MP3_IMG = "images/mp3.png";
let DOC_M4V_IMG = "images/m4v.png";
let DOC_PDF_IMG = "images/pdf.png";
let DOC_PNG_IMG = "images/png.png";
let DOC_PPT_IMG = "images/ppt.png";
let DOC_TIFF_IMG = "images/tif.png";
let DOC_TXT_IMG = "images/txt.png";
let DOC_XLS_IMG = "images/xls.png";


function getDocImg(AExt) {

  let vFileExt = AExt ? AExt.toLowerCase() : "";

  let vDocImg = DOC_UNKNOWN_IMG;

  switch (vFileExt) {
    case '.doc':
    case '.docx':
      vDocImg = DOC_WORD_IMG;
      break;
    case '.dwg':
      vDocImg = DOC_DWG_IMG;
      break;
    case '.htm':
    case '.html':
      vDocImg = DOC_HTML_IMG;
      break;
    case '.jpg':
    case '.jpeg':
    case '.bmp':
    case '.gif':
    case '.ico':
      vDocImg = DOC_JPG_IMG;
      break;
    case '.m4v':
      vDocImg = DOC_M4V_IMG;
      break;
    case '.mov':
      vDocImg = DOC_MOV_IMG;
      break;
    case '.mp3':
      vDocImg = DOC_MP3_IMG;
      break;
    case '.mp4':
      vDocImg = DOC_MP4_IMG;
      break;
    case '.msg':
      vDocImg = DOC_MSG_IMG;
      break;
    case '.pdf':
      vDocImg = DOC_PDF_IMG;
      break;
    case '.png':
      vDocImg = DOC_PNG_IMG;
      break;
    case '.ppt':
    case '.pptx':
      vDocImg = DOC_PPT_IMG;
      break;
    case '.tif':
    case '.tiff':
      vDocImg = DOC_TIFF_IMG;
      break;
    case '.txt':
    case '.ini':
      vDocImg = DOC_TXT_IMG;
      break;
    case '.xls':
    case '.xlsx':
      vDocImg = DOC_XLS_IMG;
      break;
  }

  return vDocImg;
}


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      sx={{
        display: value === index ? 'block' : 'none',
        width: 1,
        maxWidth: 1,
        minWidth: 0,
      }}
      {...other}
    >
      {value === index && children}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

function MainContent(props) {

  const { iniSelDocID,
    onViewDoc, onDownloadDoc, onDeleteDoc, folder, searchDocs,
    updatedDoc,
    // totalDocCnt,
    onPrintIndex, onSearch, onDocDetail,
    onRefresh, afterDocDetailUpdate, disableUpload,
    onDocGridReady, onInfiniteDocGridReady, onFetchedDoc, onError,
    isMonitorOffline,
    isExternal,
  } = props;
  const sysID = props.sysID || "";

  const folders = props.folders || [];


  const theme = useTheme();
  // console.log("folders", folders);

  // Get Gloabl Event and dispatcher
  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const userID = gState.userID || "";

  const compactMode = gState.useCompactMode || false;

  const [showLoading, setShowLoading] = useState(false);
  const [showInfo, setShowInfo] = useState(true);


  const [sortedDocs, setSortedDocs] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState([]);

  // const [ragResetToken, setRagResetToken] = useState(0);

  // const handleResetRagChat = () => {
  //   // console.log('handleResetRagChat');
  //   setRagResetToken((prev) => prev + 1);
  // };

  const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);


  let isSelPhyLocFolder = false;
  if (folder) {
    const vParentFolder = folders.find(f => f.id === folder.ParentID)
    isSelPhyLocFolder = folder.IsPhyLocFolder === true || vParentFolder?.IsPhyLocFolder === true
  }

  const selFolderID = (folder?.id == undefined ? DmsCommon.VOID_FOLDER_ID : folder?.id);


  useEffect(() => {
    const vShowInfo = ((localStorage.showInfo || "1") === '1');
    // console.log(' useEffect ~ vShowInfo:', vShowInfo);
    if (vShowInfo !== showInfo) {
      setShowInfo(vShowInfo);
    }

  }, [])


  const [openPassInDocDialog, setOpenPassInDocDialog] = useState(false);
  const [doneIniSelDoc, setDoneIniSelDoc] = useState(false);

  const handleConfirmOpenPassInFileClick = () => {
    onViewDoc && onViewDoc(iniSelDocID);
  }

  const onCatchPromiseError = (e) => {
    if (onError) {
      onError(e);
    }
  }


  const [passInDocSubject, setPassInDocSubject] = useState("");

  const getCurGridRef = () => {
    if (useInfinite) {
      return gridInfiniteRef
    } else {
      return gridRef
    }
  }

  const [openGridSetting, setOpenGridSetting] = useState(false);
  const [gridColumnState, setGridColumnState] = useState([]);


  const getSortColOfCurrentGrid = () => {
    let vSortCol = '';
    let vSortDesc = null;
    try {
      const vGridColumnState = getCurrentGridColumnState();
      if (vGridColumnState) {
        vGridColumnState.forEach((s) => {
          if (s.sortIndex === 0) {
            vSortCol = s.colId;
            vSortDesc = (s.sort === 'desc');
          }
        })
      }
    } catch {
      // pass
    }
    return [vSortCol, vSortDesc];

  }
  const [useInfinite, setUseInfinite] = useState(true);

  const FIRST_LOT_DATA_MAX = 300;

  useEffect(() => {
    // console.log("useEffect [folder]");

    let isMounted = true;

    const aFunc = async () => {

      setShowLoading(true);
      try {
        let vRecordCnt = 0;
        let vData = [];

        if (selFolderID === DmsCommon.SEARCH_FOLDER_ID) {
          vRecordCnt = searchDocs.length;
          vData = searchDocs;
        } else if (selFolderID === DmsCommon.PHY_LOC_FOLDER_ID) {
          vRecordCnt = 0
        } else if (sysID) {

          const [vSortCol, vSortDesc] = getSortColOfCurrentGrid();


          if (isSelPhyLocFolder) {

            // Get first 300 Data with detail with docType only (don't need tags / comments )
            const r = await DmsService.getDocsPromise2(
              gState.sessionID, sysID, DmsCommon.VOID_FOLDER_ID,
              '', folder?.FolderName || '', 0, '', 0, FIRST_LOT_DATA_MAX, false, true,
              vSortCol, vSortDesc, true);

            vRecordCnt = r.recordCnt;
            vData = r.docs;

          } else {

            // Get first 300 Data with detail with docType only (don't need tags / comments )
            const r = await DmsService.getDocsPromise2(
              gState.sessionID, sysID, selFolderID,
              '', '', 0, '', 0, FIRST_LOT_DATA_MAX, false, true,
              vSortCol, vSortDesc, true);

            vRecordCnt = r.recordCnt;
            vData = r.docs;

          }

        }


        const [vSortCol, vSortDesc] = getSortColOfCurrentGrid();

        if (isMounted) {
          setFirstFetchDocsWithRecCnt({
            "data": vData,
            "recordCnt": vRecordCnt,
            "sortCol": vSortCol,
            "sortDesc": vSortDesc,
          })

          setSelectedDocs([]);

        }




      } catch (e) {
        // console.log("error", e);
        onError && onError(e);
      } finally {
        setShowLoading(false);
      }



    }
    aFunc();

    return () => {
      isMounted = false;
    };

  }, [folder]);

  const [firstFetchDocsWithRecCnt, setFirstFetchDocsWithRecCnt] = useState({});

  useEffect(() => {

    const { data, recordCnt } = firstFetchDocsWithRecCnt;

    let vUseInfiniteGrid = false;

    if (![DmsCommon.SEARCH_FOLDER_ID, DmsCommon.PHY_LOC_FOLDER_ID].includes(selFolderID)) {
      vUseInfiniteGrid = (recordCnt > FIRST_LOT_DATA_MAX);
    }

    const vGridInfiniteApi = gridInfiniteRef?.current?.api;

    if (vGridInfiniteApi) {
      if (vUseInfiniteGrid) {
        vGridInfiniteApi.setDatasource(docListDS);
      } else {
        vGridInfiniteApi.setDatasource(null);
      }
      vGridInfiniteApi.deselectAll();

    }


    const api = gridRef?.current?.api;
    if (api) {
      api.deselectAll();
    }


    setUseInfinite(vUseInfiniteGrid);

    setSortedDocs(data);

    onFetchedDoc && onFetchedDoc(data, recordCnt);


  }, [firstFetchDocsWithRecCnt]);


  useEffect(() => {
    // console.log("useEffect MainContent[updatedDoc]", updatedDoc);

    if (updatedDoc) {

      // console.log(' useEffect ~ updatedDoc:', updatedDoc);
      // console.log(' useEffect ~ docDetail:', docDetail);
      if (docDetail?.DocID === updatedDoc.DocID) {
        const newDocDetail = { ...docDetail, ...updatedDoc };
        // console.log(' useEffect ~ newDocDetail:', newDocDetail);
        setDocDetail(newDocDetail);

      }


      const api = getCurGridRef()?.current?.api;
      if (api) {
        const rowNode = api.getRowNode(updatedDoc.DocID.toString());
        // console.log(' handleOpenDoc ~ rowNode:', rowNode);

        if (rowNode) {
          const findDoc = rowNode.data;

          if (findDoc) {

            // Update data in grid
            const updatedItem = {
              ...findDoc,
              "RevNo": updatedDoc.RevNo,
              "FolderID": updatedDoc.FolderID,
              "Subject": updatedDoc.Subject,
              "FileName": updatedDoc.Filename,
              "FileExt": DmsCommon.getFileExtension(updatedDoc.Filename),
              "FileSize": updatedDoc.Filesize,
              "FileSizeDisplay": DmsCommon.getReadableFileSizeString(updatedDoc.Filesize),
              "UpdBy": updatedDoc.UploadByUser,
              "OurRef": updatedDoc.OurRef,
              "DocType": updatedDoc.DocType,
              "DocRef": updatedDoc.DocRef,
              "Company": updatedDoc.Company,
              "Sender": updatedDoc.Sender,
              "Recipient": updatedDoc.Recipient,
              "FileLoc": updatedDoc.FileLocation,
              "Keywords": updatedDoc.Keywords,
              "CheckOut": updatedDoc.CheckOut,
            };

            if (updatedDoc.DocDate) {
              const vDocDate = dayjs(updatedDoc.DocDate);
              updatedItem["DocDate"] = vDocDate.format(DmsCommon.SHORT_DATE_FORMAT);
              updatedItem["DocDateJs"] = vDocDate;
            } else {
              updatedItem["DocDate"] = "";
              updatedItem["DocDateJs"] = null;
            }
            if (updatedDoc.RecDate) {
              const vRecDate = dayjs(updatedDoc.RecDate);
              updatedItem["ReceiveDate"] = vRecDate.format(DmsCommon.SHORT_DATE_FORMAT);
              updatedItem["ReceiveDateJs"] = vRecDate;
            } else {
              updatedItem["ReceiveDate"] = "";
              updatedItem["ReceiveDateJs"] = null;
            }
            if (updatedDoc.LastModifyDate) {
              const vLastModifyDate = dayjs(updatedDoc.LastModifyDate);
              updatedItem["UpdDate"] = vLastModifyDate.format(DmsCommon.SHORT_DATE_FORMAT);
              updatedItem["UpdDateJs"] = vLastModifyDate;
            } else {
              updatedItem["UpdDate"] = "";
              updatedItem["UpdDateJs"] = null;
            }


            rowNode?.setData(updatedItem);

          }


        }
      }
    }


  }, [updatedDoc]);

  useEffect(() => {
    // console.log("useEffect MainContent[sortedDocs]")



    const aFunc = async () => {


      // Open pass in document
      if (iniSelDocID > 0 && !doneIniSelDoc) {

        // console.log("useEffect iniSelDocID: getDocs");
        const { docs: vRst } = await DmsService.getDocsPromise2(
          gState.sessionID, sysID, 0, '', '', iniSelDocID);
        const vDocData = (vRst.length > 0) ? vRst[0] : null;

        if (vDocData) {
          setPassInDocSubject(vDocData.Subject);
          setOpenPassInDocDialog(true);
        }

        // Select the document (if found)
        const { api } = getCurGridRef()?.current;
        if (api) {
          const rowNode = api.getRowNode(iniSelDocID.toString());
          rowNode?.setSelected(true);
        }

        setDoneIniSelDoc(true);

      }



    }
    aFunc();




  }, [sortedDocs])



  const gridRef = React.useRef();
  const gridInfiniteRef = React.useRef();

  const showCheckHist = ['DMS_DE', 'DMS_FM'].includes(sysID);



  const rowClassRules = {
    'unread-doc': function (params) { return params.data?.HasRead === false; }
  };

  const handleDocDetailClick = (aSysID, aDocID) => {
    // console.log("handleDocDetailClick", aSessionID, aSysID, aDocID);
    // console.log("handleDocDetailClick gState.sessionID", gState.sessionID);
    onDocDetail && onDocDetail(aSysID, aDocID);
  }


  const handleOpenClick = () => {
    // console.log("selectedDocs", selectedDocs);
    handleOpenDoc(selectedDocs[0].DocID);
  }

  const handleInfoClick = () => {


    // console.log("selectedDocs", selectedDocs);
    const vDoc = selectedDocs[selectedDocs.length - 1];
    handleDocDetailClick(vDoc.SysID, vDoc.DocID);

  }


  const onSelectionChanged = (params) => {
    // console.log('Selection Changed', params);
    let nodes = params.api.getSelectedNodes();

    let selDocs = nodes.map(item => {
      return item.data
    });

    setSelectedDocs(selDocs);

    if (selDocs.length > 0) {
      const vDoc = selDocs[selDocs.length - 1];
      getDocDetail(gState.sessionID, vDoc.SysID, vDoc.DocID);
    } else {
      setDocDetail(null);
    }

  }



  const handleOpenDoc = (ADocID) => {
    // console.log('handleOpenDoc:', ADocID);
    if (folder?.IsMonitorFolder && isMonitorOffline) {
      onError && onError(new Error("The path is offline"));
      return;
    }

    if (isExternal && folder?.IsMonitorFolder && !folder?.InternetAccess) {
      onError && onError(new Error("Access denied: Internet access is not enabled for this folder!"));
      return;
    }

    const { api } = getCurGridRef()?.current;
    if (api) {
      const rowNode = api.getRowNode(ADocID.toString());
      // console.log(' handleOpenDoc ~ rowNode:', rowNode);

      if (rowNode) {
        const findDoc = rowNode.data;

        if (findDoc && (findDoc.HasRead === false)) {

          // Get unreadCnt
          let vNewUnreadCnt = folder.UnreadCnt - 1;

          // Update data in grid
          const updatedItem = {
            ...findDoc,
            HasRead: true,
          };

          rowNode?.setData(updatedItem);

          // Dispatch changes
          if (folder) {
            if (vNewUnreadCnt >= 0) {
              gEventDispatch({
                UpdateDocUnReadCnt: { folderID: folder.id, unreadCnt: vNewUnreadCnt },
              });
              folder.UnreadCnt = vNewUnreadCnt;
            }

          }

        }
      }
    }


    onViewDoc && onViewDoc(ADocID);
  }


  // const inputFileRef = React.useRef();

  // const [openUploadSingleFileDialog, setOpenUploadSingleFileDialog] = useState(false);




  const handleDownloadClick = () => {
    // console.log("handleDownloadClick", selectedDocs);
    if (folder?.IsMonitorFolder && isMonitorOffline) {
      onError && onError(new Error("The path is offline"));
      return;
    }

    if (isExternal && folder?.IsMonitorFolder && !folder?.InternetAccess) {
      onError && onError(new Error("Access denied: Internet access is not enabled for this folder!"));
      return;
    }

    // Update data in grid
    const { api } = getCurGridRef()?.current;

    const selNodes = [];
    selectedDocs.forEach((d) => {
      const rowNode = api.getRowNode(d.DocID.toString());
      if (rowNode && (rowNode.data)) {
        selNodes.push(rowNode);
      }

    });

    if (selNodes.some(n => n.data.FileName === "")) {
      const e = new Error(`Blank File can't be viewed or downloaded!`)
      onCatchPromiseError(e);
      return
    }

    if (selNodes.some(n => n.data.HasRead === false)) {

      // Get unreadCnt
      let vNewUnreadCnt = folder.UnreadCnt;

      // Update data in grid
      selNodes.forEach((rowNode) => {

        const nodeData = rowNode.data;
        if (nodeData && (nodeData.HasRead === false)) {
          // Update data in grid
          const updatedItem = {
            ...nodeData,
            HasRead: true,
          };
          rowNode?.setData(updatedItem);

          vNewUnreadCnt -= 1;
        }
      });

      // console.log(' handleDownloadClick ~ vNewUnreadCnt:', vNewUnreadCnt);

      // Dispatch changes
      if (folder) {
        gEventDispatch({
          UpdateDocUnReadCnt: { folderID: folder.id, unreadCnt: vNewUnreadCnt },
        });
        folder.UnreadCnt = vNewUnreadCnt;

      }

    }

    let vDocIDList = selNodes.map(rowNode => {
      return ({
        "DocID": rowNode.data.DocID,
        "RevNo": rowNode.data.RevNo,
      })
    });
    // console.log("vDocIDList", vDocIDList);

    onDownloadDoc && onDownloadDoc(vDocIDList);

  }



  // const [openOTLinkDialog, setOpenOTLinkDialog] = useState(false);

  // const handleOneTimeLinkClick = () => {

  //   setOpenOTLinkDialog(true);
  // }


  const [openDelDialog, setOpenDelDialog] = useState(false);
  const [openPrintIdxDialog, setOpenPrintIdxDialog] = useState(false);
  // const [openSearchDialog, setOpenSearchDialog] = useState(false);
  const [confirmText, setConfirmText] = useState("");



  const handleDelClick = () => {
    if (folder?.IsMonitorFolder && isMonitorOffline) {
      onError && onError(new Error("The path is offline"));
      return;
    }
    setConfirmText(`Delete the selected ${selectedDocs.length} record(s)?`);
    setOpenDelDialog(true);
  }

  const handleConfirmDeleteClick = async () => {
    // console.log("handleConfirmDeleteClick");

    let vDocIDList = selectedDocs.map(d => d.DocID);
    // console.log("vDocIDList", vDocIDList);

    if (onDeleteDoc) {
      const isSuccess = await onDeleteDoc(vDocIDList);
      if (isSuccess) {
        // Update unread count for folders if any deleted doc was unread
        const unreadCountByFolder = {};
        selectedDocs.forEach(d => {
          if (d.HasRead === false) {
            const fId = d.FolderID || folder?.id;
            if (fId) {
              unreadCountByFolder[fId] = (unreadCountByFolder[fId] || 0) + 1;
            }
          }
        });

        Object.entries(unreadCountByFolder).forEach(([fIdStr, count]) => {
          const fId = parseInt(fIdStr);
          const targetFolder = folders.find(f => f.id === fId);
          const currentUnread = targetFolder?.UnreadCnt ?? (fId === folder?.id ? folder?.UnreadCnt : 0);
          const newUnread = Math.max(0, (currentUnread || 0) - count);
          gEventDispatch({
            UpdateDocUnReadCnt: { folderID: fId, unreadCnt: newUnread },
          });
          if (targetFolder) {
            targetFolder.UnreadCnt = newUnread;
          }
          if (folder && folder.id === fId) {
            folder.UnreadCnt = newUnread;
          }
        });

        // Remove from local grid state
        const docIDSet = new Set(vDocIDList);
        setSortedDocs(prev => prev.filter(d => !docIDSet.has(d.DocID)));
        setSelectedDocs([]);

        const api = getCurGridRef()?.current?.api;
        if (api) {
          const rowsToRemove = [];
          vDocIDList.forEach(id => {
            const rowNode = api.getRowNode(id.toString());
            if (rowNode?.data) {
              rowsToRemove.push(rowNode.data);
            }
          });
          if (rowsToRemove.length > 0) {
            api.applyTransaction({ remove: rowsToRemove });
          }
          if (useInfinite) {
            api.refreshInfiniteCache();
          }
          api.deselectAll();
        }
      }
    }
  };

  const handlePrintIndex = (APrintFolderID, ADocIDs, AIncludeSubFolder, AIncludeRight, AIncludeComment, AExportExcel) => {
    onPrintIndex && onPrintIndex(APrintFolderID, ADocIDs, AIncludeSubFolder, AIncludeRight, AIncludeComment, AExportExcel);
  }

  const handleSearchDialogReturn = (aSearchFolderID, aSearchStr, aUseElastic, aDocDateFrom, aDocDateTo, aAdvSearchCriteria) => {
    // setOpenSearchDialog(false);

    onSearch && onSearch(aSearchFolderID, aSearchStr, aUseElastic, aDocDateFrom, aDocDateTo, aAdvSearchCriteria);
  }

  const [openFolderInfoDialog, setOpenFolderInfoDialog] = useState(false);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);

  const handleUploadClick = () => {
    if (folder?.IsMonitorFolder && isMonitorOffline) {
      onError && onError(new Error("The path is offline"));
      return;
    }
    setOpenUploadDialog(true);
  }


  const isDMS_PL = (sysID === 'DMS_PL');

  const isMonitorFolder = folder?.IsMonitorFolder || false;

  const deleteEnabled = !isDMS_PL && folder && (folder.Grade >= DmsCommon.AccessRightEnum.arModifyDel || folder.Grade == -1) && selectedDocs.length > 0

  const downloadEnabled = folder && (folder.Grade >= DmsCommon.AccessRightEnum.arReadDn || folder.Grade == -1) && selectedDocs.length > 0

  const openEnabled = folder && selectedDocs.length === 1
  const docInfoEnabled = folder && selectedDocs.length === 1

  const printDisabled = (sysID == "" || isSelPhyLocFolder)

  const searchDisabled = (sysID == "" || isSelPhyLocFolder)
  const [searchBtnChecked, setSearchBtnChecked] = useState(false);

  const handleSearchBtnClick = () => {
    setSearchBtnChecked(!searchBtnChecked);
    // setOpenSearchDialog(true);
  }
  const containerRef = useRef(null);

  const [ragWidth, setRagWidth] = useState(() => {
    return Number(localStorage.getItem("ragWidth") || 380);
  });

  const isDragging = useRef(false);

  // save width
  useEffect(() => {
    localStorage.setItem("ragWidth", ragWidth);
  }, [ragWidth]);

  const handleMouseDown = () => {
    isDragging.current = true;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;

    const containerRect = containerRef.current.getBoundingClientRect();

    const newWidth = containerRect.right - e.clientX;

    // limit width (optional)
    if (newWidth < 250 || newWidth > 800) return;

    setRagWidth(newWidth);
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };



  const cellStyle = useMemo(() => ({
    paddingLeft: '10px', paddingRight: '10px',
    fontSize: compactMode ? '0.7rem' : '0.8rem'
  }), [compactMode]);

  useEffect(() => {

    if (gridRef.current?.api) {
      gridRef.current.api.resetRowHeights();
      gridRef.current.api.refreshCells({ force: true });
    }

    if (gridInfiniteRef.current?.api) {
      gridInfiniteRef.current.api.resetRowHeights();
      gridInfiniteRef.current.api.refreshCells({ force: true });
    }

    // Refresh to make sure the new compact mode can be applied to all cells (especially for the height of rows)
    handleRefresh();
  }, [compactMode])

  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAfterDocDetailUpdate = () => {
    // console.log('handleAfterDocDetailUpdate', docDetail);
    docDetail && afterDocDetailUpdate && afterDocDetailUpdate(gState.sessionID, sysID, docDetail.DocID);
  }

  const FileTypeRenderer = (params) => {

    // const vCompactMode = params.context?.compactMode;

    let vImgSrc = "images/loading.gif";
    const vValue = params.value;

    if (vValue !== undefined) {
      vImgSrc = getDocImg(vValue)
    }

    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={vImgSrc}
          alt={vValue || "unknown"}
          style={{
            width: compactMode ? 20 : 32,
            height: compactMode ? 20 : 32,
            objectFit: "contain",
          }}
        />
      </div>
    );
  }

  const CheckOutRenderer = (params) => {
    return (<Box
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      {params.value === true && (
        <DriveFileMoveIcon
          color="success"
          sx={{ fontSize: compactMode ? 20 : 32 }}


        />
      )}
    </Box>)
  }

  const handleRefresh = () => {
    onRefresh && onRefresh();
  }


  const getCurrentGridColumnState = () => {
    // console.log('getCurrentGridColumnState');
    const vCurGrid = getCurGridRef();
    if (vCurGrid.current) {
      const { columnApi } = vCurGrid.current;
      if (columnApi) {
        const vState = columnApi.getColumnState();
        // console.log('getCurrentGridColumnState:', vState);
        return vState;

      } else {
        return [];
      }

    }

  }

  const handleGridSetting = () => {
    const vState = getCurrentGridColumnState();
    setGridColumnState(vState);

    setOpenGridSetting(true);

  }



  const applyState = (aAggridColState) => {
    // console.log(' applyState ~ aAggridColState:', aAggridColState);
    if (aAggridColState) {
      setGridColumnState(aAggridColState);

      if (gridInfiniteRef) {
        gridInfiniteRef.current?.columnApi?.applyColumnState({
          state: aAggridColState,
          applyOrder: true,

        });
      }
      if (gridRef) {
        gridRef.current?.columnApi?.applyColumnState({
          state: aAggridColState,
          applyOrder: true,
        });
      }
    }

  }

  const onUpdateGridColState = (aAggridColState) => {
    console.log(' onUpdateGridColState ~ aAggridColState:', aAggridColState);
    applyState(aAggridColState);

    localStorage.aggridColState = JSON.stringify(aAggridColState);
  }


  const resetGridState = () => {
    console.log('resetGridState');
    if (gridInfiniteRef.current) {
      const columnApi = gridInfiniteRef.current?.columnApi;
      if (columnApi) {
        columnApi.resetColumnState();
      }
    }
    if (gridRef.current) {
      const columnApi = gridRef.current?.columnApi;
      if (columnApi) {
        columnApi.resetColumnState();
      }
    }

  };

  const handleRestoreGridDefault = () => {
    console.log('handleRestoreGridDefault');
    resetGridState();

    const vAggridColState = getCurrentGridColumnState();
    // console.log(' handleRestoreGridDefault ~ vAggridColState:', vAggridColState);
    setGridColumnState(vAggridColState);

    localStorage.aggridColState = JSON.stringify(vAggridColState);
  }

  const restoreState = useCallback(() => {
    if (!localStorage.aggridColState) {
      return;
    }

    if (gridRef && gridInfiniteRef) {
      const vAggridColState = JSON.parse(localStorage.aggridColState || "[]");

      // Somehow a small delay is needed or the "width" of the columns cannot be applied
      // when the page is newly loaded
      setTimeout(() => {
        // console.log('restoreState aggridColState', vAggridColState);

        applyState(vAggridColState);
      }, 100);
    }




  }, [window]);


  const adjForShowInfo = (showInfo && selectedDocs.length >= 1);


  const transferGridSetting = (aGrid1, aGrid2) => {
    // console.log(' transferGridSetting');
    if (aGrid1.current) {
      const { columnApi } = aGrid1.current;
      if (columnApi) {
        const vNewState = columnApi.getColumnState();

        // console.log(' transferGridSetting ~ vNewState:', vNewState);

        // Save setting
        if (vNewState) {
          localStorage.aggridColState = JSON.stringify(vNewState);
        }

        if (vNewState && aGrid2.current) {

          // console.log(' onGridColChanged ~ aGrid2.current:', aGrid2.current);

          const { columnApi: columnApi2 } = aGrid2.current;
          // console.log(' onGridColChanged ~ columnApi2:', columnApi2);
          if (columnApi2) {

            columnApi2.applyColumnState({
              state: vNewState,
              applyOrder: true,
              applyColumnState: true,
            });

          }
        }

      }
    }
  }


  const onGridColChanged = () => {

    if (useInfinite === true) { return }

    // console.log(' onGridColChanged');

    transferGridSetting(gridRef, gridInfiniteRef);

  }

  const onGridInfiniteColChanged = () => {

    if (useInfinite === false) { return }

    // console.log(' onGridInfiniteColChanged');

    transferGridSetting(gridInfiniteRef, gridRef);

  }


  const refreshDisabled = (folder ? false : true);


  // const { files, openFileDialog } = useFileDialog();

  const [iniFile, setIniFile] = useState(null);
  const [docTypes, setDocTypes] = useState([]);

  const [useBlankFile, setUseBlankFile] = useState(false);

  const handleUploadOk = (aFile, aUseBlankFile) => {

    setOpenUploadDialog(false);
    setIniFile(aFile);
    setUseBlankFile(aUseBlankFile);

    DmsService.getDocTypesPromise(gState.sessionID, sysID)
      .then((values) => {
        setDocTypes(values);

        setOpenUploadSingleFileDialog(true);
      })

  }


  // useEffect(() => {
  //   // console.log('useEffect[files]', files);
  //   const vFileList = files;

  //   if (vFileList && vFileList.length === 1) {
  //     const vFiles = [...vFileList];
  //     setIniFile(vFiles[0]);

  //     DmsService.getDocTypesPromise(gState.sessionID, sysID)
  //       .then((values) => {
  //         setDocTypes(values);

  //         setOpenUploadSingleFileDialog(true);
  //       })

  //   }

  // }, [files]);

  const [openUploadSingleFileDialog, setOpenUploadSingleFileDialog] = useState(false);

  const handleAfterUploadFile = () => {
    setOpenUploadSingleFileDialog(false);
    handleRefresh();
  }


  const [docDetail, setDocDetail] = useState(null);

  const getDocDetail = async (aSessionID, aSysID, aDocID) => {
    // console.log("getDocDetail", aSessionID, aSysID, aDocID);

    let isMounted = true;

    try {
      const p1 = DmsService.getDocDetailPromise(aSessionID, aSysID, aDocID);
      const p2 = DmsService.getDocTypesPromise(aSessionID, aSysID);

      const [docDetail, docTypes] = await Promise.all([p1, p2]);

      if (isMounted) {
        setDocDetail(docDetail);

        setDocTypes(docTypes);
      }

    } catch (e) {
      onCatchPromiseError(e);
    }

    return () => {
      isMounted = false;
    };
  }




  const handleChangeShowInfo = (e) => {
    // onChangeShowInfo && onChangeShowInfo(e.target.checked);
    setShowInfo(e.target.checked);
    localStorage.showInfo = e.target.checked ? '1' : '0';
  };

  const compareStrInsensitive = (a, b) => {
    const aStrA = a || '';
    const aStrB = b || '';
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }


  const comparatorFileSize = (a, b, nodeA, nodeB) => {
    return nodeA.data.FileSize - nodeB.data.FileSize;
  }

  const compareDate = (aDate1, aDate2) => {
    if (aDate1.isBefore(aDate2)) {
      return -1;
    } else if (aDate1.isAfter(aDate2)) {
      return 1;
    } else {
      return 0;
    }
  }

  const comparatorStrField = (a, b) => compareStrInsensitive(a, b);


  const comparatorDocDate = (a, b, nodeA, nodeB) => {

    const [aDate1, aDate2] = [nodeA.data.DocDateJs, nodeB.data.DocDateJs];
    return compareDate(aDate1, aDate2)
  }

  const comparatorUpdDate = (a, b, nodeA, nodeB) => {

    const [aDate1, aDate2] = [nodeA.data.UpdDateJs, nodeB.data.UpdDateJs];
    return compareDate(aDate1, aDate2)
  }

  const comparatorRecDate = (a, b, nodeA, nodeB) => {

    const [aDate1, aDate2] = [nodeA.data.ReceiveDateJs, nodeB.data.ReceiveDateJs];
    return compareDate(aDate1, aDate2)
  }



  const onRowDoubleClicked = (e) => {
    // console.log("onRowDoubleClicked", e);
    if (e.data) {
      handleOpenDoc(e.data.DocID);
    }
  }

  const defaultColDef = useMemo(() => ({
    width: 100,
    resizable: true,
    sortable: true,
    // suppressMovable: true,
  }), []);
  const defaultColDef2 = useMemo(() => ({
    width: 100,
    resizable: true,
    sortable: true,
    // suppressMovable: true,
  }), []);

  const columnDefs = useMemo(() => [

    {
      field: 'FileExt',
      cellRenderer: FileTypeRenderer,
      headerName: "Type", cellStyle: cellStyle,
      headerClass: "center-header",
      width: 100,
      headerCheckboxSelection: true,
      checkboxSelection: true,
      rowDrag: false,
      suppressMovable: true,
    },
    {
      field: 'CheckOut',
      cellRenderer: CheckOutRenderer,
      headerName: " ", cellStyle: cellStyle,
      width: 50,
      rowDrag: false,
      suppressMovable: true,
      sortable: false,
    },
    {
      field: 'Subject', headerName: "Subject", cellStyle: cellStyle, minWidth: 200
      // , flex: "1"
      , comparator: comparatorStrField
    },
    {
      field: 'DocDate', headerName: "Doc Date", cellStyle: cellStyle, width: 120
      , comparator: comparatorDocDate
    },
    {
      field: 'FileSizeDisplay', headerName: "Size", type: "rightAligned", cellStyle: cellStyle, width: 120
      , comparator: comparatorFileSize
    },
    {
      field: 'UpdDate', headerName: "Last Rev Upload Date", cellStyle: cellStyle, width: 120
      , comparator: comparatorUpdDate
    },
    {
      field: 'UpdBy', headerName: "Last Rev Upload By", cellStyle: cellStyle, width: 120
      , comparator: comparatorStrField
    },
    {
      field: 'OurRef', headerName: "Our Ref No", cellStyle: cellStyle, width: 120
      , comparator: comparatorStrField
    },
    {
      field: 'DocType', headerName: "Doc Type", cellStyle: cellStyle, width: 120
      , comparator: comparatorStrField
    },
    {
      field: 'Sender', headerName: "Sender", cellStyle: cellStyle, width: 120
      , comparator: comparatorStrField
    },
    {
      field: 'Company', headerName: "Company/Department", cellStyle: cellStyle, width: 120
      , comparator: comparatorStrField
    },
    {
      field: 'Recipient', headerName: "Recipient", cellStyle: cellStyle, width: 120
      , comparator: comparatorStrField
    },
    {
      field: 'DocRef', headerName: "Ref No", cellStyle: cellStyle, width: 120
      , comparator: comparatorStrField
    },
    {
      field: 'ReceiveDate', headerName: "Receive Date", cellStyle: cellStyle, width: 120
      , comparator: comparatorRecDate
    },
    {
      field: 'FileLoc', headerName: "File Loc", cellStyle: cellStyle, width: 120
      , comparator: comparatorStrField
    },
    {
      field: 'Keywords', headerName: "Keywords", cellStyle: cellStyle, width: 120
      , comparator: comparatorStrField
    },

    // { field: 'DocID', cellRenderer: FileInfoRenderer, headerName: " ", sortable: false, cellStyle: cellStyle, width: 62 },
  ], [compactMode, cellStyle]);

  const columnDefs2 = useMemo(() => [
    {
      field: 'FileExt',
      cellRenderer: FileTypeRenderer,
      headerName: "Type", cellStyle: cellStyle,
      headerClass: "center-header",
      width: 100,
      // headerCheckboxSelection: true,
      checkboxSelection: true,
      rowDrag: false,
      suppressMovable: true,
    },
    {
      field: 'CheckOut',
      cellRenderer: CheckOutRenderer,
      headerName: " ", cellStyle: cellStyle,
      width: 50,
      rowDrag: false,
      suppressMovable: true,
      sortable: false,
    },
    {
      field: 'Subject', headerName: "Subject", cellStyle: cellStyle, minWidth: 200,
    },
    {
      field: 'DocDate', headerName: "Doc Date", cellStyle: cellStyle, width: 120
    },
    {
      field: 'FileSizeDisplay', headerName: "Size", type: "rightAligned", cellStyle: cellStyle, width: 120
    },
    {
      field: 'UpdDate', headerName: "Last Rev. Upload Date", cellStyle: cellStyle, width: 120
    },
    {
      field: 'UpdBy', headerName: "Last Rev. Upload By", cellStyle: cellStyle, width: 120
    },
    {
      field: 'OurRef', headerName: "Our Ref No", cellStyle: cellStyle, width: 120
    },
    {
      field: 'DocType', headerName: "Doc Type", cellStyle: cellStyle, width: 120, //sortable: false
    },
    {
      field: 'Sender', headerName: "Sender", cellStyle: cellStyle, width: 120
    },
    {
      field: 'Company', headerName: "Company/Department", cellStyle: cellStyle, width: 120
    },
    {
      field: 'Recipient', headerName: "Recipient", cellStyle: cellStyle, width: 120
    },
    {
      field: 'DocRef', headerName: "Ref No", cellStyle: cellStyle, width: 120
    },
    {
      field: 'ReceiveDate', headerName: "Receive Date", cellStyle: cellStyle, width: 120
    },
    {
      field: 'FileLoc', headerName: "File Loc", cellStyle: cellStyle, width: 120
    },
    {
      field: 'Keywords', headerName: "Keywords", cellStyle: cellStyle, width: 120
    },
    // { field: 'DocID', cellRenderer: FileInfoRenderer, headerName: " ", sortable: false, cellStyle: cellStyle, width: 62 },
  ], [compactMode, cellStyle]);

  const rowDragText = (params, dragItemCount) => {
    if (dragItemCount > 1) {
      return dragItemCount + ' files';
    }
    return params.rowNode.data.Subject;
  }

  const handleGetRowId = useCallback((params) => params.data.DocID, []);

  const onGridReady = useCallback((params) => {
    restoreState();
    onDocGridReady && onDocGridReady(params)

  }, []);

  const onInfiniteGridReady = useCallback((params) => {
    restoreState();
    onInfiniteDocGridReady && onInfiniteDocGridReady(params)

  }, []);



  const Input = styled('input')({
    display: 'none',
  });


  const docListDS = {

    rowCount: undefined,
    getRows: (params) => {
      // console.log(' docListDS ~ params:', params);

      const xFunc = async () => {
        setShowLoading(true);
        try {

          if (sysID === "") {
            params.successCallback([], 0);

          } else {
            let vFolderID = (folder?.id == undefined ? DmsCommon.VOID_FOLDER_ID : folder?.id);

            // console.log('asking for ' + params.startRow + ' to ' + params.endRow);

            // if (vFolderID === DmsCommon.SEARCH_FOLDER_ID) {
            //   params.successCallback(searchDocs, searchDocs.length);
            // } else if (vFolderID === DmsCommon.PHY_LOC_FOLDER_ID) {
            //   params.successCallback([], 0);
            // } else {
            // let vPhyLoc = ''
            // if (folder?.IsPhyLocFolder === true) {
            //   vFolderID = DmsCommon.VOID_FOLDER_ID;
            //   vPhyLoc = folder?.FolderName || "";
            // }
            let vDocs = [];
            let vRecordCnt = 0;

            let vSortCol = '';
            let vSortDesc = null;
            try {
              if (params.sortModel) {
                const vSortOption = params.sortModel[0];
                vSortCol = vSortOption.colId;
                vSortDesc = (vSortOption.sort === 'desc');
              }
            } catch {
              // pass
            }



            // } else {
            if (isSelPhyLocFolder) {
              const { docs, recordCnt } = await DmsService.getDocsPromise2(
                gState.sessionID, sysID, DmsCommon.VOID_FOLDER_ID,
                '', folder?.FolderName || "", 0, '', params.startRow, params.endRow,
                false, true, vSortCol, vSortDesc, true);
              vDocs = docs;
              vRecordCnt = recordCnt;
            } else {
              const { docs, recordCnt } = await DmsService.getDocsPromise2(
                gState.sessionID, sysID, vFolderID,
                '', '', 0, '', params.startRow, params.endRow,
                false, true, vSortCol, vSortDesc, true);
              vDocs = docs;
              vRecordCnt = recordCnt;
            }

            // }




            // // if on or after the last page, work out the last row.
            let lastRow = -1;
            if (vRecordCnt <= params.endRow) {
              lastRow = vRecordCnt;
            }
            // call the success callback
            params.successCallback(vDocs, lastRow);
          }

          // }

        } catch (e) {
          // setDocs([]);

          console.log("docListDS error:", e);
          onError && onError(e);
        } finally {
          setShowLoading(false);
        };




      }
      xFunc();



    },
  };

  const vFolderRagEnabled = folder?.RagEnabled || false;

  const [ragPanelVisible, setRagPanelVisible] = useState(() => {
    const saved = localStorage.getItem("ragPanelVisible");
    return saved ? (saved === 'true') : true;
  });

  useEffect(() => {
    localStorage.setItem("ragPanelVisible", ragPanelVisible);
  }, [ragPanelVisible]);


  const handleRagSwitchClick = (e) => {
    setRagPanelVisible(e.target.checked);
  };


  const vGridRowHeight = compactMode ? 22 : 38;
  const vGridHeaderHeight = compactMode ? 24 : 38;

  const tabHeaderHeight = compactMode ? 32 : 48;

  return (

    <Box sx={{
      display: 'flex',
      width: 1,
      flexDirection: 'row',
      flexGrow: 1,
      // flex: 1,
      p: 0
    }}

    >
      <CssBaseline />

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>


      <ConfirmDialog
        open={openDelDialog}
        // selectCnt={selectedDocs.length}

        text={confirmText}
        confirmBtnCaption='Delete'
        onCancelClick={() => {
          setOpenDelDialog(false);
        }}
        onConfirmClick={() => {
          setOpenDelDialog(false);
          handleConfirmDeleteClick();
        }}
      />

      <ConfirmDialog
        open={openPassInDocDialog}

        text={`Open file [${passInDocSubject}]?`}
        confirmBtnCaption='Open'
        onCancelClick={() => {
          setOpenPassInDocDialog(false);
        }}
        onConfirmClick={() => {
          setOpenPassInDocDialog(false);
          handleConfirmOpenPassInFileClick();
        }}
      />

      <PrintIndexDialog
        open={openPrintIdxDialog}
        folderID={folder?.id}
        searchViewDocIDs={searchDocs.map(d => d.DocID)}
        selectDocIDs={selectedDocs.map(d => d.DocID)}
        onClose={() => {
          setOpenPrintIdxDialog(false);
        }}
        onPrintIndex={handlePrintIndex}
      />

      {/* <SearchDialog
        sysID={sysID}
        open={openSearchDialog}
        onClose={() => {
          setOpenSearchDialog(false);
        }}
        onSearch={handleSearchDialogReturn}
        folders={folders}
        folderID={folder?.id}
      /> */}

      <FolderInfoDialog
        sysID={sysID}
        open={openFolderInfoDialog}
        onClose={() => setOpenFolderInfoDialog(false)}
        folder={folder}
      />

      <UploadDialog
        open={openUploadDialog}
        onClose={() => setOpenUploadDialog(false)}
        onOk={handleUploadOk}
      />

      <UploadSingleFileDialog
        sysID={sysID}
        folderID={selFolderID}
        open={openUploadSingleFileDialog}
        iniFile={iniFile}
        useBlankFile={useBlankFile}
        docTypes={docTypes}
        onClose={() => setOpenUploadSingleFileDialog(false)}
        onAfterUpload={handleAfterUploadFile}
        onError={onCatchPromiseError}
      />

      <GridSettingDialog
        open={openGridSetting}
        onClose={() => setOpenGridSetting(false)}
        columnDefs={columnDefs}
        columnState={gridColumnState}
        onUpdateState={onUpdateGridColState}
        onRestoreDefault={handleRestoreGridDefault}
      />

      <Box component="div"
        sx={{
          display: 'flex', flexDirection: 'column', flexGrow: 1,
          p: 0, height: 1, maxHeight: 1, overflow: 'auto',
        }}

      >
        <Box sx={{ py: 0.1, px: 1, display: 'flex', flexDirection: 'row', }}  >

          <Button sx={{ display: { xs: "none", lg: "flex" } }} color="primary" disabled={disableUpload} size="small" startIcon={<CloudUploadIcon />}
            // onClick={openFileDialog}
            onClick={handleUploadClick}
          >
            Upload
          </Button>
          <Button sx={{ display: { xs: "none", lg: "flex" } }} color="primary" disabled={!downloadEnabled} size="small" startIcon={<CloudDownloadIcon />} onClick={handleDownloadClick} >
            Download
          </Button>
          <Button sx={{ display: { xs: "none", lg: "flex" } }} color="primary" disabled={!openEnabled} size="small" startIcon={<TextSnippetIcon />} onClick={handleOpenClick} >
            Open
          </Button>
          {/* <Button color="primary" disabled={!downloadEnabled} size="small" startIcon={<LinkIcon />} onClick={handleOneTimeLinkClick} >
            OT Link
          </Button> */}
          {/* <Button color="primary" disabled={selectedDocs.length === 0} size="small" startIcon={<EmailIcon />}>
            Email
          </Button> */}
          <Button sx={{ display: { xs: "none", lg: "flex" } }} color="primary" disabled={printDisabled} size="small" startIcon={<LocalPrintshopIcon />} onClick={() => setOpenPrintIdxDialog(true)} >
            Print
          </Button>
          <Button sx={{ display: { xs: "none", lg: "flex" } }} color="primary" disabled={!deleteEnabled} size="small" startIcon={<DeleteIcon />} onClick={() => setOpenDelDialog(true)} >
            Delete
          </Button>
          <Button sx={{ display: { xs: "none", lg: "flex" } }} color="primary"
            // disabled={searchDisabled}
            // onClick={() => setOpenSearchDialog(true)}
            onClick={handleSearchBtnClick}
            variant={searchBtnChecked ? "contained" : "text"}
            size="small"
            startIcon={<SearchIcon />}
          >
            Search
          </Button>
          <Button sx={{ display: { xs: "none", lg: "flex" } }} color="primary" disabled={!docInfoEnabled} size="small" startIcon={<InfoIcon />} onClick={handleInfoClick} >
            Info
          </Button>
          <Button sx={{ display: { xs: "none", lg: "flex" } }} color="primary" size="small" startIcon={<SettingsApplicationsIcon />} onClick={handleGridSetting} >
            Columns
          </Button>

          <Button sx={{ display: { xs: "none", lg: "flex" } }} color="primary" disabled={refreshDisabled} size="small" startIcon={<RefreshIcon />} onClick={handleRefresh} >
            Refresh
          </Button>

          <IconButton sx={{ display: { xs: "flex", lg: "none" } }} color="primary" disabled={disableUpload} component="span"
            // onClick={openFileDialog}
            onClick={handleUploadClick}
          >
            <CloudUploadIcon />
          </IconButton>
          <IconButton sx={{ display: { xs: "flex", lg: "none" } }} color="primary" disabled={!downloadEnabled} component="span" onClick={handleDownloadClick}>
            <CloudDownloadIcon />
          </IconButton>
          <IconButton sx={{ display: { xs: "flex", lg: "none" } }} color="primary" disabled={!openEnabled} component="span" onClick={handleOpenClick}>
            <TextSnippetIcon />
          </IconButton>
          {/* <IconButton color="primary" disabled={!downloadEnabled} component="span" onClick={handleOneTimeLinkClick}>
            <LinkIcon />
          </IconButton> */}
          {/* <IconButton color="primary" disabled={selectedDocs.length === 0} component="span">
            <EmailIcon />
          </IconButton> */}
          <IconButton sx={{ display: { xs: "flex", lg: "none" } }} color="primary" disabled={printDisabled} component="span" onClick={() => setOpenPrintIdxDialog(true)} >
            <LocalPrintshopIcon />
          </IconButton>
          <IconButton sx={{ display: { xs: "flex", lg: "none" } }} color="primary" disabled={!deleteEnabled} component="span" onClick={handleDelClick}>
            <DeleteIcon />
          </IconButton>
          <IconButton
            sx={{ display: { xs: "flex", lg: "none" } }}
            color="primary"
            component="span"
            onClick={handleSearchBtnClick}
          >
            {searchBtnChecked ? <PageviewSharpIcon /> : <PageviewOutlinedIcon />}
          </IconButton>
          <IconButton sx={{ display: { xs: "flex", lg: "none" } }} color="primary" disabled={!docInfoEnabled} component="span" onClick={handleInfoClick} >
            <InfoIcon />
          </IconButton>

          <IconButton sx={{ display: { xs: "flex", lg: "none" } }} color="primary" component="span" onClick={handleGridSetting} >
            <SettingsApplicationsIcon />
          </IconButton>

          <IconButton sx={{ display: { xs: "flex", lg: "none" } }} color="primary" disabled={refreshDisabled} component="span" onClick={handleRefresh} >
            <RefreshIcon />
          </IconButton>
          {/* {vFolderRagEnabled && (
            <IconButton
              sx={{ display: { xs: "flex", lg: "none" } }}
              color="primary"
              component="span"
              onClick={handleRagBtnClick}
            >
              {ragPanelVisible ? <ChatIcon /> : <ChatBubbleOutlineOutlinedIcon />}
            </IconButton>

          )} */}


          {/* <div style={{ flex: '2 0 0' }} />
          <Button sx={{ display: { xs: "none", lg: "flex" } }} color="primary" size="small" startIcon={<SettingsApplicationsIcon />} onClick={handleGridSetting} >
            Columns
          </Button>
          <IconButton sx={{ display: { xs: "flex", lg: "none" } }} color="primary" component="span" onClick={handleGridSetting} >
            <SettingsApplicationsIcon />
          </IconButton> */}
          <div style={{ flex: '1 0 0' }} />

          {vFolderRagEnabled && (
            <Box sx={{ alignContent: 'center', }}  >
              <FormGroup >
                <FormControlLabel
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: compactMode ? 12 : 14,
                    },
                  }}
                  control={
                    <Switch
                      checked={ragPanelVisible}
                      onClick={handleRagSwitchClick}
                      size={compactMode ? "small" : "medium"}
                      sx={{
                        "& .MuiSwitch-thumb": {
                          width: compactMode ? 12 : 20,
                          height: compactMode ? 12 : 20,
                        },
                        "& .MuiSwitch-track": {
                          borderRadius: compactMode ? 10 : 12,
                        },
                      }}
                    />
                  } label="RAG" />

              </FormGroup>
            </Box>
          )}
          <Box sx={{ alignContent: 'center', }}  >
            <FormGroup >
              <FormControlLabel
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: compactMode ? 12 : 14,
                  },
                }}
                control={
                  <Switch
                    checked={showInfo}
                    onChange={handleChangeShowInfo}
                    size={compactMode ? "small" : "medium"}
                    sx={{
                      "& .MuiSwitch-thumb": {
                        width: compactMode ? 12 : 20,
                        height: compactMode ? 12 : 20,
                      },
                      "& .MuiSwitch-track": {
                        borderRadius: compactMode ? 10 : 12,
                      },
                    }}
                  />
                } label="Detail" />
            </FormGroup>
          </Box>
        </Box>
        <Box component="div"
          sx={{
            display: searchBtnChecked ? 'flex' : 'none', p: 0, height: "450px", maxHeight: 1,
            overflow: 'auto',
          }}
        >
          <SearchDialogContent
            sysID={sysID}
            onSearch={handleSearchDialogReturn}
            folders={folders}
          // folderID={folder?.id}
          />
        </Box>
        <Box component="div"
          sx={{ display: 'flex', p: 0, height: 1, maxHeight: 1, overflow: 'hidden' }}
          ref={containerRef}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
        >

          <Box className="ag-theme-material" sx={{
            height: "100%",
            // flexGrow: 1, ...(useInfinite && { display: 'none' })
            flex: 1,
            display: (useInfinite ? "none" : "flex"),
            flexDirection: "column",
            overflow: "hidden",
          }}
          >
            <AgGridReact
              ref={gridRef}
              key={`standard-${compactMode}`}
              rowData={sortedDocs}

              defaultColDef={defaultColDef}
              columnDefs={columnDefs}
              suppressMultiSort

              context={{ compactMode }}
              rowHeight={vGridRowHeight}
              headerHeight={vGridHeaderHeight}

              suppressNoRowsOverlay
              rowClassRules={rowClassRules}

              rowSelection={"multiple"}

              // rowDragManaged={true}
              rowDragMultiRow={!isMobileDevice}
              rowDragEntireRow={!isMobileDevice}
              rowDragText={rowDragText}


              // suppressRowClickSelection
              onSelectionChanged={onSelectionChanged}
              // onCellClicked={onCellClicked}

              onRowDoubleClicked={onRowDoubleClicked}

              getRowId={handleGetRowId}

              suppressMoveWhenRowDragging={true}
              onGridReady={onGridReady}

              onSortChanged={() => { // console.log(' onSortChanged1');
                onGridColChanged();
              }}
              onColumnResized={() => { // console.log(' onColumnResized1');
                onGridColChanged();
              }}
              onColumnMoved={() => { // console.log(' onColumnMoved1');
                onGridColChanged();
              }}
            />
          </Box>
          <Box className="ag-theme-material" sx={{
            height: "100%",
            // flexGrow: 1, ...(!useInfinite && { display: 'none' })

            flex: 1,
            display: (useInfinite ? "flex" : "none"),
            flexDirection: "column",
            overflow: "hidden",
          }}
          >
            <AgGridReact
              ref={gridInfiniteRef}
              key={`infinite-${compactMode}`}
              rowModelType={"infinite"}

              defaultColDef={defaultColDef2}
              columnDefs={columnDefs2}
              suppressMultiSort

              context={{ compactMode }}
              rowHeight={vGridRowHeight}
              headerHeight={vGridHeaderHeight}

              suppressNoRowsOverlay
              rowClassRules={rowClassRules}

              rowSelection={"multiple"}

              // rowDragManaged={true}
              rowDragMultiRow={!isMobileDevice}
              rowDragEntireRow={!isMobileDevice}
              rowDragText={rowDragText}


              // suppressRowClickSelection
              onSelectionChanged={onSelectionChanged}
              // onCellClicked={onCellClicked}

              onRowDoubleClicked={onRowDoubleClicked}

              getRowId={handleGetRowId}

              suppressMoveWhenRowDragging={true}
              onGridReady={onInfiniteGridReady}

              onSortChanged={() => { // console.log(' onSortChanged2');
                onGridInfiniteColChanged();
              }}
              onColumnResized={() => { // console.log(' onColumnResized2');
                onGridInfiniteColChanged();
              }}
              onColumnMoved={() => { // console.log(' onColumnMoved2');
                onGridInfiniteColChanged();
              }}
            />
          </Box>

          <Box
            sx={{
              width: 300,
              minWidth: 300,
              maxWidth: 300,
              height: "100%",
              border: '1px solid grey',
              overflow: 'hidden',
              display: adjForShowInfo ? 'flex' : 'none',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                p: 1,
                overflow: 'hidden',
              }}
            >

              {selectedDocs.length == 1 && docDetail && (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                  }}
                >
                  <Tabs
                    value={value}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                      flexShrink: 0,
                      minHeight: tabHeaderHeight,
                      "& .MuiTabs-indicator": {
                        height: compactMode ? 2 : 3,
                      },
                    }}
                  >
                    <Tab
                      label="Document Info."
                      {...a11yProps(0)}
                      sx={{
                        fontSize: compactMode ? 11 : undefined,
                        minHeight: tabHeaderHeight,
                        py: compactMode ? 0.25 : undefined,
                        px: compactMode ? 1 : undefined,
                      }}
                    />
                    {showCheckHist && (
                      <Tab
                        label="Check Out/In"
                        {...a11yProps(1)}
                        sx={{
                          fontSize: compactMode ? 11 : undefined,
                          minHeight: tabHeaderHeight,
                          py: compactMode ? 0.25 : undefined,
                          px: compactMode ? 1 : undefined,
                        }}
                      />

                    )}
                  </Tabs>

                  <Box
                    sx={{
                      flex: 1,
                      minHeight: 0,
                      overflow: 'hidden',
                    }}
                  >
                    <TabPanel value={value} index={0} dir={theme.direction}>
                      <Box
                        sx={{
                          height: "76vh",
                          overflowY: 'auto',
                          overflowX: 'hidden',
                          px: 1,
                          pb: 1,
                          boxSizing: 'border-box',
                        }}
                      >
                        <DocInfoTab
                          sysID={sysID}
                          docDetail={docDetail}
                          docTypes={docTypes}
                          folders={folders}
                          compactMode={compactMode}
                          readonly={true}
                          alwayEdit={false}
                          notInDialog
                        />
                      </Box>
                    </TabPanel>

                    <TabPanel value={value} index={1} dir={theme.direction}>
                      <DocCheckHistTab
                        sysID={sysID}
                        docDetail={docDetail}
                        docFolder={folder}
                        afterUpdate={handleAfterDocDetailUpdate}
                        compactMode={compactMode}
                        cardViewMode={true}
                      />
                    </TabPanel>
                  </Box>
                </Box>
              )}

              {selectedDocs.length > 1 && (<>
                <Box width={"100%"}>
                  <Alert severity="success" >{selectedDocs.length} documents selected</Alert>
                </Box>
              </>

              )}
            </Box>
          </Box>

          {vFolderRagEnabled && ragPanelVisible && (
            <>

              {/* DIVIDER */}
              <Box
                onMouseDown={handleMouseDown}
                sx={{
                  width: "5px",
                  cursor: "col-resize",
                  bgcolor: "divider",
                  "&:hover": {
                    bgcolor: "primary.main",
                  },
                }}
              />

              {/* RAG Panel */}
              <Box component="div" sx={{
                flexDirection: 'column',
                width: ragWidth,
                p: 1, height: "85vh", maxHeight: "85vh", border: '1px solid grey',
                overflow: 'hidden',
                display: 'flex',
              }}
              >
                <RagMessagingDialog
                  title="RAG"
                  folder={folder}
                  folders={folders}
                  // resetToken={ragResetToken}
                  sysID={sysID}
                  userID={userID}
                  onDocLinkClick={(docID) => {
                    // console.log("Doc link clicked in RAG dialog, docID:", docID);
                    handleOpenDoc(docID);
                  }}
                />

              </Box>
            </>
          )}

        </Box>
      </Box>


    </Box >


  );
}

// FileTypeCellRender.propTypes = {
//   value: PropTypes.string,
// }

MainContent.propTypes = {
  sysID: PropTypes.string,
  folder: PropTypes.object,
  folders: PropTypes.array,
  // totalDocCnt: PropTypes.number,
  searchDocs: PropTypes.array,
  onDrawerToggle: PropTypes.func,
  iniSelDocID: PropTypes.number,
  onViewDoc: PropTypes.func,
  onDownloadDoc: PropTypes.func,
  onDeleteDoc: PropTypes.func,
  onPrintIndex: PropTypes.func,
  onSearch: PropTypes.func,
  onDocDetail: PropTypes.func,
  onRefresh: PropTypes.func,
  afterDocDetailUpdate: PropTypes.func,
  disableUpload: PropTypes.bool,
  onDocGridReady: PropTypes.func,
  onInfiniteDocGridReady: PropTypes.func,
  updatedDoc: PropTypes.object,
  onFetchedDoc: PropTypes.func,
  onError: PropTypes.func,
  isMonitorOffline: PropTypes.bool,
  isExternal: PropTypes.bool,
};

export default MainContent